var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDescription(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.40755 13.5H10.0742V11.8334H3.40755V13.5ZM3.40755 10.1667H10.0742V8.50002H3.40755V10.1667ZM1.74089 16.8334C1.28255 16.8334 0.890191 16.6702 0.563802 16.3438C0.237413 16.0174 0.0742188 15.625 0.0742188 15.1667V1.83335C0.0742188 1.37502 0.237413 0.982659 0.563802 0.65627C0.890191 0.329881 1.28255 0.166687 1.74089 0.166687H8.40755L13.4076 5.16669V15.1667C13.4076 15.625 13.2444 16.0174 12.918 16.3438C12.5916 16.6702 12.1992 16.8334 11.7409 16.8334H1.74089ZM7.57422 6.00002V1.83335H1.74089V15.1667H11.7409V6.00002H7.57422Z",
    fill: "#04B7B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDescription);
export default __webpack_public_path__ + "static/media/description.d64fbfad8d97d62ec37ea0201d4c729a.svg";
export { ForwardRef as ReactComponent };